import React, { useState, useEffect, useContext } from "react";

import { useQuery, useMutation, useApolloClient } from "react-apollo";

import { Field, Control, Button, Icon, Tab, Title } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  useParams,
  // useHistory,
  useLocation,
  Route,
  Link,
  Switch
} from "react-router-dom";
import {
  SINGLE_USER_QUERY,
  UPDATE_USER_MUTATION
  // DELETE_USER_MUTATION
} from "../../../graphql/Users/Users.graphql";
import { EMPLOYEE_EXISTS_ON_USER_QUERY } from "../../../graphql/Employees/Employees.graphql";

import Loading from "../../../components/Loading";

import { ModalContext } from "../../../components/ModalProvider";

import { ChangePasswordForm } from "../../../components/Users";

import Details from "./routes/Details";

// import { DeleteButton } from "../../../components/inputs";

import { ourToast as toast } from "../../../utils";

const INITIAL_STATE = {
  UserId: "",
  Password: "",
  FirstName: "",
  MiddleName: "",
  LastName: "",
  Active: true,
  EmployeeRecIdRef: "",
  CompanyId: localStorage.getItem("user_company") || ""
};

function UserPage() {
  const { setModalOpen } = useContext(ModalContext);
  const client = useApolloClient();
  const { id } = useParams();
  // const history = useHistory();
  const location = useLocation();

  const { data } = useQuery(SINGLE_USER_QUERY, {
    variables: { where: { RecId: parseInt(id) } }
  });

  const [updateUser, { loading }] = useMutation(UPDATE_USER_MUTATION, {
    refetchQueries: ["SINGLE_LOCATION_QUERY", "ALL_LOCATIONS_QUERY"]
  });

  const [editing, setEditing] = useState(true);
  const [inputs, setInputs] = useState(INITIAL_STATE);
  const [FromEmployee, setFromEmployee] = useState(false);

  useEffect(() => {
    setInputs(data?.User);
    setFromEmployee(!!data?.User?.EmployeeRecIdRef);
  }, [data]);

  const toggleEditing = () => setEditing(!editing);

  const onChange = async e => {
    if (e.target.name === "FromEmployee") {
      setFromEmployee(e.target.checked);
      if (!e.target.checked) {
        setEditing(true);
      }
    } else if (
      e.target.name === "EmployeeRecIdRef" &&
      parseInt(e.target.value) !== data?.User?.EmployeeRecIdRef
    ) {
      try {
        const {
          data: { EmployeeExistsOnUser }
        } = await client.query({
          query: EMPLOYEE_EXISTS_ON_USER_QUERY,
          variables: {
            RecId: parseInt(e.target.value)
          },
          fetchPolicy: "network-only"
        });
        if (EmployeeExistsOnUser) {
          setInputs({
            ...inputs,
            LastName: EmployeeExistsOnUser.Employee.LastName,
            FirstName: EmployeeExistsOnUser.Employee.FirstName,
            MiddleName: EmployeeExistsOnUser.Employee.MiddleName,
            EmployeeRecIdRef: parseInt(EmployeeExistsOnUser.Employee.RecId)
          });
        } else {
          setInputs({
            ...inputs,
            LastName: "",
            FirstName: "",
            MiddleName: "",
            EmployeeRecIdRef: 0,
            UserId: ""
          });
          toast.error("The selected employee is being used by another user.");
        }
      } catch (error) {
        toast.error("Error getting User Information.");
      }
    } else if (e.target.name === "EmployeeRecIdRef") {
      setInputs(data?.User);
    } else {
      const value =
        e.target.type === "checkbox" ? e.target.checked : e.target.value;
      setInputs({ ...inputs, [e.target.name]: value });
    }
  };

  const handleSave = async e => {
    e.preventDefault();
    try {
      const obj = Object.keys(INITIAL_STATE).reduce(
        (acc, curr) =>
          inputs[curr] !== null ? { ...acc, [curr]: inputs[curr] } : acc,
        {}
      );
      await updateUser({
        variables: {
          data: {
            ...obj,
            EmployeeRecIdRef:
              obj.EmployeeRecIdRef && FromEmployee
                ? parseInt(obj.EmployeeRecIdRef, 10)
                : null
          },
          where: { RecId: parseInt(id) }
        }
      });
      setEditing(false);
      toast.success("User updated successfully.");
    } catch (err) {
      toast.error("Error updating User.");
    }
  };

  if (loading || !data?.User) return <Loading />;

  const getActionButtons = () => {
    if (location.pathname.includes("groups")) {
      return (
        <Field kind="group">
          <Control>
            <Button color="success" size="small" onClick={() => {}}>
              <Icon>
                <FontAwesomeIcon icon="plus" />
              </Icon>
              <span>Add Group</span>
            </Button>
          </Control>
        </Field>
      );
    }
    return (
      <Field kind="group">
        <Control>
          <Button
            color="primary"
            disabled={editing}
            size="small"
            onClick={toggleEditing}
          >
            <Icon>
              <FontAwesomeIcon icon="edit" />
            </Icon>
            <span>Edit</span>
          </Button>
        </Control>
        {/* <Control>
          <DeleteButton
            mutation={DELETE_USER_MUTATION}
            refetchQueries={["ALL_USERS_QUERY", "SINGLE_USER_QUERY"]}
            size="small"
            variables={{ where: { RecId: parseInt(id) } }}
            onComplete={() => history.push("/admin/users")}
          />
        </Control> */}
        <Control>
          <Button
            color="link"
            size="small"
            onClick={() =>
              setModalOpen(
                true,
                <ChangePasswordForm
                  user={inputs}
                  onComplete={() => setModalOpen(false, "")}
                />
              )
            }
          >
            <Icon>
              <FontAwesomeIcon icon="key" />
            </Icon>
            <span>Change Password</span>
          </Button>
        </Control>
        <Control>
          <Button
            color="success"
            disabled={!editing}
            size="small"
            onClick={handleSave}
          >
            <Icon>
              <FontAwesomeIcon icon="save" />
            </Icon>
            <span>Save</span>
          </Button>
        </Control>
      </Field>
    );
  };
  return (
    <React.Fragment>
      <header className="page-head">
        <div className="page-head-start">
          <Title color="primary" size={1}>
            {`${inputs?.FirstName} ${inputs?.LastName}`}
          </Title>
        </div>
        <div className="page-head-end">{getActionButtons()}</div>
      </header>
      <Tab.Group kind="boxed">
        <Tab
          active={location.pathname.includes("details")}
          as={Link}
          tabIndex="-1"
          to="details"
        >
          <span>Details</span>
        </Tab>
      </Tab.Group>
      <div className="page-tab-container">
        <Switch>
          <Route path="/admin/users/:id/details">
            <Details
              FromEmployee={FromEmployee}
              editing={editing}
              id={id}
              inputs={inputs}
              onChange={onChange}
            />
          </Route>
        </Switch>
      </div>
    </React.Fragment>
  );
}

UserPage.propTypes = {};

export default UserPage;
